<template>
  <div class="vcnSystmList section-main__warp1 flex-valign">
    <div class="svnSystem-main flex-auto">
      <vcnsystem ref="Vcn" :sel="deviceType" />
    </div>
  </div>
</template>
<script>
import vcnsystem from "../components/VCN/VcnSystemList";

export default {
  components: {
    vcnsystem,
  },
  data() {
    return {
      deviceType: "",
    };
  },
  mounted() {},
  // 当退出设备接入模块时销毁存储的设备类型
  destroyed() {
    if (this.$route.path.indexOf("deviceaccess") === -1) {
      localStorage.removeItem("devTyp");
    }
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.vcnSystmList {
  width: 100%;
  height: 100%;
  .svnSystem-main {
    width: 100%;
    overflow: hidden;
  }

  /deep/.el-tabs__nav-wrap::after {
    background-color: #3e5574;
  }
}
</style>
